import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export class PayoutRequestSelectors {
  static state = (state: AppState) => state.payoutRequests;
  static hasLoaded = createSelector(this.state, state => state.status !== 'pending' && state.status !== 'loading');
  static payoutRequests = createSelector(this.state, state => state.payoutRequests);
  static openRequest = createSelector(this.state, state => state.payoutRequests.find(r => r.status === 'open'));
}
